import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import clsx from 'clsx';
import React, { useContext } from 'react';
import { ModalContext, ModalOverlay, Modal, OverlayTriggerStateContext, Dialog } from 'react-aria-components';
import { IconButton } from '../IconButton/IconButton.es.js';
import { ModalDialogBody } from './Body.es.js';
import { ModalDialogFooter } from './Footer.es.js';
import { ModalDialogHeader } from './Header.es.js';
import { ModalDialogTrigger } from './Trigger.es.js';

const modalOverlay = "_modal-overlay_tnz36_17";
const fadeIn = "_fade-in_tnz36_1";
const fadeOut = "_fade-out_tnz36_1";
const modal = "_modal_tnz36_17";
const dialog = "_dialog_tnz36_57";
const closeButton = "_close-button_tnz36_71";
const styles = {
	modalOverlay: modalOverlay,
	fadeIn: fadeIn,
	fadeOut: fadeOut,
	modal: modal,
	dialog: dialog,
	closeButton: closeButton
};

const ModalDialogRoot = (_a) => {
  var { children, className, isDismissable = true, isOpen, onOpenChange } = _a, props = __rest(_a, ["children", "className", "isDismissable", "isOpen", "onOpenChange"]);
  const contextValue = React.useMemo(() => ({ isDismissable }), [isDismissable]);
  return React.createElement(
    ModalContext.Provider,
    { value: contextValue },
    React.createElement(
      ModalOverlay,
      { className: styles.modalOverlay, "data-zds": true, isOpen, isKeyboardDismissDisabled: !isDismissable, onOpenChange },
      React.createElement(
        Modal,
        { className: clsx(className, styles.modal), "data-zds": true },
        React.createElement(ModalDialogInner, { "aria-label": props["aria-label"], "aria-labelledby": props["aria-labelledby"] }, children)
      )
    )
  );
};
const ModalDialogInner = (_a) => {
  var { children } = _a, props = __rest(_a, ["children"]);
  const state = useContext(OverlayTriggerStateContext);
  const close = React.useCallback(() => state === null || state === void 0 ? void 0 : state.close(), [state]);
  const modalContext = useContext(ModalContext);
  return React.createElement(
    Dialog,
    { "aria-label": props["aria-label"], "aria-labelledby": props["aria-labelledby"], className: styles.dialog, "data-zds": true },
    (modalContext === null || modalContext === void 0 ? void 0 : modalContext.isDismissable) && React.createElement(IconButton, { className: styles.closeButton, name: "formX", onPress: close, variant: "ghost", "aria-label": "Close modal" }),
    typeof children === "function" ? children({ close }) : children
  );
};
const ModalDialog = {
  /**
   * The dialog's main content.
   */
  Body: ModalDialogBody,
  /**
   * The dialog footer, which should contain up to two buttons:
   * - an optional secondary button
   * - an required primary button
   */
  Footer: ModalDialogFooter,
  /**
   * The dialog header containing a descriptive title of the dialog content.
   */
  Header: ModalDialogHeader,
  /**
   * A modal dialog shown above other content in an application.
   */
  Root: ModalDialogRoot,
  /**
   * A trigger container that listens for a button press to open the modal dialog. It should wrap around a `design-system-beta` `Button` and `Modal.Root`.
   *
   * **Should only be used when the `ModalDialog`'s open state is uncontrolled**
   */
  Trigger: ModalDialogTrigger
};

export { ModalDialog, ModalDialogRoot, ModalDialog as default };
//# sourceMappingURL=ModalDialog.es.js.map
